export default __webpack_public_path__ + "static/media/vip1.6c25bd7e.gif";